import { appEnvironment, appName } from '@benzinga/utils';

export const FREESTAR_VALID_CHANNELS = ['home', 'money', 'article', 'quote', 'sponsored', 'data', 'channel'] as const;

export type FreestarChannel = (typeof FREESTAR_VALID_CHANNELS)[number];

export const FREESTAR_DEFAULT_CHANNEL: FreestarChannel = 'channel';

const DATA_PREFIXES = [
  '/markets',
  '/screener',
  '/premarket',
  '/calendars',
  '/calendar',
  '/tools',
  '/heatmap',
  '/dividends',
  '/earnings',
  '/fda-calendar',
  '/analyst-stock-ratings',
  '/short-interest',
  '/government-trades',
  '/secfilings',
  '/futures',
];

const startsWithAny = (pathname: string, prefixes: string[]) =>
  prefixes.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));

const DATED_ARTICLE_PATH_REGEX = /\/[0-2][0-9]\/[0-1][0-9]\/\d+(?:\/|$)/;

export const isArticlePath = (pathname: string | null | undefined): boolean => {
  if (!pathname) return false;
  if (pathname === '/article' || pathname.startsWith('/article/')) return true;
  if (/^\/content\/\d+(?:\/|$)/.test(pathname)) return true;
  if (
    pathname.startsWith('/pressreleases/') ||
    pathname.startsWith('/press-releases/') ||
    pathname.startsWith('/secfilings/')
  ) {
    return true;
  }
  return DATED_ARTICLE_PATH_REGEX.test(pathname);
};

export const isMoneyPath = (pathname: string | null | undefined): boolean => {
  if (appEnvironment().isApp(appName.money)) return true;
  if (!pathname) return false;
  return pathname === '/money' || pathname.startsWith('/money/');
};

export const resolveFreestarChannel = (pathname?: string): FreestarChannel => {
  if (isMoneyPath(pathname)) return 'money';

  if (!pathname) return FREESTAR_DEFAULT_CHANNEL;
  if (pathname === '/') return 'home';
  if (pathname.startsWith('/quote')) return 'quote';
  if (pathname.startsWith('/sponsored') || pathname.startsWith('/partner-content')) return 'sponsored';
  if (isArticlePath(pathname)) return 'article';
  if (startsWithAny(pathname, DATA_PREFIXES)) return 'data';
  return FREESTAR_DEFAULT_CHANNEL;
};
